import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { faArrowUp,
  faArrowRight,
  faAngleRight,
  faSignIn,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faUserPlus,
  faSignOut,
  faPaperPlane,
  faChurch,
  faPray,
  faHeart,
  faCog,
  faUsers,
  faPlus,
  faCaretRight,
  faUserAlt,
  faCaretUp,
  faCaretDown,
  faReply,
  faComment,
  faCheckCircle,
  faInfoCircle,
  faBooks,
  faEnvelopeOpen,
  faCircle,
  faCaretLeft,
  faBible,
  faCubes,
  faTrash } from '@fortawesome/pro-solid-svg-icons'

import {
  faArrowLeft,
  faPen,
  faCheck,
  faShareAlt,
  faEnvelope,
  faUser,
  faSync
} from '@fortawesome/pro-light-svg-icons'

export default function registerIcons (Vue) {
  // Register global icon component
  Vue.component('vue-fontawesome', FontAwesomeIcon)

  library.add(
    faArrowUp,
    faArrowRight,
    faArrowLeft,
    faAngleRight,
    faExclamationCircle,
    faSignIn,
    faEye,
    faEyeSlash,
    faUserPlus,
    faSignOut,
    faPaperPlane,
    faChurch,
    faPray,
    faHeart,
    faCog,
    faUsers,
    faPlus,
    faEnvelope,
    faCaretRight,
    faUserAlt,
    faCaretUp,
    faCaretDown,
    faReply,
    faPen,
    faEnvelopeOpen,
    faComment,
    faCheck,
    faCheckCircle,
    faExclamationTriangle,
    faInfoCircle,
    faBooks,
    faShareAlt,
    faCaretLeft,
    faBible,
    faCircle,
    faCubes,
    faUser,
    faEnvelopeOpen,
    faTrash,
    faSync
  )
}
